<template>
  <div id="ConfigCache">
    <b-row>
      <b-col>
        <h2 class="pb-3">Cache Management</h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-tabs lazy>
          <b-tab title="Purge manually" active>
            <ConfigCachePurge />
          </b-tab>
          <b-tab title="Purge All">
            <ConfigCachePurgeAll />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ConfigCachePurge from '@/views/config/ConfigCachePurge'
import ConfigCachePurgeAll from '@/views/config/ConfigCachePurgeAll'
export default {
  name: 'ConfigCache',
  components: {
    ConfigCachePurge,
    ConfigCachePurgeAll
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/config/ConfigCache.vue